import { useEffect, useRef } from "react";
import { useContent } from "../../context/ContentContext";

const FALLBACK = [
  { n: "01", tag: "The Arena", title: "Global Stage", body: "Where India's creative elite are forged into a movement." },
  { n: "02", tag: "The Circle", title: "The Network", body: "Every invitation connects you to those who are already chosen." },
  { n: "03", tag: "The Prize", title: "Real Stakes", body: "Contracts. Runways. Franchises. This is not exposure. This is entry." },
];

const Manifesto = () => {
  const { content } = useContent();
  const cols = content?.manifesto?.columns?.length ? content.manifesto.columns : FALLBACK;

  const sectionRef = useRef(null);
  useEffect(() => {
    const els = sectionRef.current?.querySelectorAll(".reveal");
    if (!els) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in")),
      { threshold: 0.2 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [cols.length]);

  return (
    <section
      ref={sectionRef}
      id="manifesto"
      data-testid="manifesto"
      className="relative bg-black border-t border-cotton/10 py-28 md:py-36 px-6 overflow-hidden"
    >
      <div className="absolute top-0 left-6 md:left-12 w-px h-16 bg-gold/40" />
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 md:divide-x md:divide-[color:var(--ifgl-gold-dim)]">
          {cols.map((c, i) => (
            <div
              key={i}
              data-testid={`manifesto-col-${i}`}
              className={`group reveal relative ${
                i === 0 ? "md:pr-12" : "md:px-12"
              } ${i === cols.length - 1 ? "md:pl-12" : ""} py-10 md:py-2 transition-colors duration-500`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="flex items-center gap-3 mb-8">
                <span className="block w-6 h-px bg-gold/60" />
                <span className="text-[10px] tracking-[0.4em] uppercase text-gold/70 font-light">
                  {c.tag}
                </span>
              </div>
              <p
                data-testid={`manifesto-num-${i}`}
                className="text-red font-condensed font-black leading-none mb-8 transition-transform duration-700 group-hover:-translate-y-1"
                style={{ fontSize: "clamp(64px, 7vw, 120px)" }}
              >
                {c.n}
              </p>
              <h3
                className="text-cotton font-condensed font-semibold uppercase tracking-[0.08em] mb-6 transition-colors duration-500 group-hover:text-gold"
                style={{ fontSize: "clamp(22px, 2vw, 30px)" }}
              >
                {c.title}
              </h3>
              <p className="text-cotton/65 font-condensed font-light leading-relaxed text-base md:text-lg max-w-sm">
                {c.body}
              </p>
              <span className="block mt-10 h-px w-12 bg-red/50 transition-all duration-500 group-hover:w-24 group-hover:bg-red" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
